import(/* webpackMode: "eager", webpackExports: ["PortfolioClient"] */ "/vercel/path0/src/app/portfolio/PortfolioClient.tsx");
